import { useCurrentUserPermissions } from 'src/hooks/user';

import { PeosDetailsEmployersCVStaff } from './PeosDetailsEmployersCVStaff';
import { PeosDetailsEmployersPeoPayrollProvider } from './PeosDetailsEmployersPeoPayrollProvider';

interface PeosDetailsEmployersProps {
  peoId: string | undefined;
}

export const PeosDetailsEmployers: React.FC<PeosDetailsEmployersProps> = ({ peoId }) => {
  const { hasPlatformRoles, isPeoPayrollProviderUser } = useCurrentUserPermissions();

  if (hasPlatformRoles) {
    return <PeosDetailsEmployersCVStaff peoId={peoId} />;
  }

  if (isPeoPayrollProviderUser) {
    return <PeosDetailsEmployersPeoPayrollProvider peoId={peoId} />;
  }

  return null;
};
